import * as React from 'react'
import ReactDOM from 'react-dom'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './FullscreenOverlay.sass'

interface FullscreenOverlayProps {
  showing: boolean
  preventScroll?: boolean
  children?: React.ReactNode
  onTransitionEnd?: React.TransitionEventHandler
}

export default observer(
  React.forwardRef<HTMLDivElement, FullscreenOverlayProps>(
    function FullscreenOverlay(
      { showing, children, preventScroll, onTransitionEnd },
      ref,
    ) {
      return ReactDOM.createPortal(
        <div
          className={cx(
            styles.root,
            !showing && styles.hidden,
            preventScroll && styles.preventScroll,
          )}
          onTransitionEnd={onTransitionEnd}
          ref={ref}
        >
          <div className={styles.background} />
          {children}
        </div>,
        document.getElementById('app-modals-container')!,
      )
    },
  ),
)
